import { useState, useEffect } from 'react';
import { useAuthContext } from '../auth/useAuthContext';
import { PatientService } from '../api/patient.service';

/**
 * Custom hook to get the patient ID for the current user
 * @returns The patient ID for the current user if the user is a patient, otherwise null
 */
export const usePatientId = () => {
  const { user } = useAuthContext();
  const [patientId, setPatientId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPatientId = async () => {
      if (user?.roleId === 'patient' && user?.email) {
        try {
          setLoading(true);
          const patientService = new PatientService();
          const response = await patientService.getAllPatients();
          
          // Find the patient with the matching email
          const patientData = response.data.find((patient: any) => 
            patient.email === user.email
          );
          
          if (patientData) {
            setPatientId(patientData.id.toString());
          }
        } catch (error) {
          console.error('Error fetching patient ID:', error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchPatientId();
  }, [user]);

  return { patientId, loading };
};